export default __webpack_public_path__ + "static/color-neutral-palette-light-cc88e4b24e4ff9e750576578f57afb59789478218ccecc11b886d1127b09ea3b.png";